import { useNavigate } from 'react-router';

import { Button } from '@ui';

import { LINKS } from '../../utils/routes';

export const BackToActivityButton = () => {
    const navigate = useNavigate();
    return (
        <Button
            variant="secondary"
            onClick={() => {
                navigate(LINKS.getCurrentActivity());
            }}
        >
            Back
        </Button>
    );
};

export const BackToFullActivityButton = () => {
    const navigate = useNavigate();
    return (
        <Button
            variant="secondary"
            onClick={() => {
                navigate(LINKS.getFullActivity());
            }}
        >
            Back
        </Button>
    );
};
